import { Component, OnInit } from '@angular/core';
import { AdminServices, GlobalService } from '@app/services';

@Component({
    selector: 'app-send-campaigns',
    templateUrl: './send-campaigns.component.html',
    styleUrls: ['./send-campaigns.component.scss'],
    standalone: false
})
export class SendCampaignsComponent implements OnInit {
	currentUser:any = null;
  partners:any  = [];
  partnerCode:any = null;
  providerCodeCampaign:any = null;
  senders:Array<any> = [
    "ventas@mrpresta.com",
    "soporte@mrpresta.com",
    "fernanda@mrpresta.com"
  ]
  senderSelected:string = "ventas@mrpresta.com"
  constructor(
    private adminService:AdminServices,
		private globalServices:GlobalService
  ) { 

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.adminService.getAllProviders().subscribe((response)=>{
      if(!response.error){
        this.partners = response.data;
        for(let partner of this.partners){
          switch(partner.product_type){
            case 1:
              partner.name+= ' - mca'
            break;
            case 2: 
              partner.name+= ' - factoring'
              break;
            case 3: 
              partner.name+= ' - discount factoring'
              break;
          }
        }
      }
    });
  }
	
  headerPreSet:Array<string> = [
    'Cliente Id',
    'Num Contrato',
    'Oportunidad Nombre',
    'Estatus del contrato',
    'Merchant User Id',
    'Ultimo Pago',
    'Day of Expiration Date',
    'Vencido',
    'Saldo Insoluto Capital Ajustado',
    'Proporción de repago',
    'Proporción de plazo transcurrido',
    '(Prop. de repago / Prop. de plazo )',
    'Monto Preaprobado',
    'Payback',
    'Total Pago Recibido',
    'Min. Por pagar',
    'Min. Capital Pendiente',
    'Días para vencimiento',
    'Sum of Días desde último pago',
    'Categoría',
    'Acción',
    'Comentarios',
    'funded_by'
  ]
  ngOnInit(): void {
    this.verifyPermissionAccess();
  }
  fileSelected:any = {
    "headers": null,
    "data": null
  }

  fileSelectedOffer:any = {
    "headers": null,
    "data": null
  }
  permissionAccess:boolean = false;
  
  // campaigns mrp lendings
  check_whatsapp:any = null
  check_email:any = null
  check_whatsapp_campaign:any = null
  check_email_campaign:any = null
  fileName = null;
  onFileSelected(event:any){
    let file = event.target.files[0]
    this.fileName = file.name;
    let reader: FileReader = new FileReader();
    reader.readAsText(file);
    reader.onload = (e) => {
      let csvData = reader.result;
      let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
      let headersRow = this.getHeaderArray(csvRecordsArray);
      let records = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
      this.fileSelected.headers = headersRow
      this.fileSelected.data = records
      for(let item of this.fileSelected.data){
        if(item.length == 1){
          let index = this.fileSelected.data.indexOf(item);
          this.fileSelected.data.splice(index, 1);
        }
      }
    }
  }

  onFileSelectedOffer(event:any){

    let file = event.target.files[0]
    let reader: FileReader = new FileReader();
    reader.readAsText(file);
    reader.onload = (e) => {
      let csvData = reader.result;
      let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
      let headersRow = this.getHeaderArray(csvRecordsArray);
      let records = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
      this.fileSelectedOffer.headers = headersRow
      this.fileSelectedOffer.data = records

    }

  }


  send() {
    console.log(this.providerCodeCampaign);
    if (this.check_email_campaign || this.check_whatsapp_campaign) {
      if (this.fileSelected.data.length > 0) {
        this.fileSelected['user_id'] = this.currentUser.userId;
        this.fileSelected['type_of_send'] = {
          "check_whatsapp_campaign": this.check_whatsapp_campaign,
          "check_email_campaign": this.check_email_campaign
        }
        this.fileSelected['file_name'] = this.fileName;
        this.fileSelected['sender'] = this.senderSelected;
        this.fileSelected['partner_code'] = this.providerCodeCampaign;

        this.adminService.sendCampaignData(this.fileSelected).subscribe((response) => {
          if (!response.error) {
            this.globalServices.prepareAlert({
              title: "Exito",
              message: "Envio de ofertas iniciado correctamente...",
              label: 'success'
            }).subscribe(res => { })
          } else {
            alert(`Error enviando la campana, ${response.message}`);
          }
        });
      } else {
        this.globalServices.prepareAlert({
          title: "Error",
          message: "No existe archivo",
          label: 'error'
        }).subscribe(res => { })
      }
    } else {
      this.globalServices.prepareAlert({
        title: "Error",
        message: "Seleccione un metodo de envio",
        label: 'error'
      }).subscribe(res => { })
    }
  }

  sendOffers(){
    if (this.partnerCode) {
      if (this.check_whatsapp || this.check_email) {
        if (this.fileSelectedOffer.data.length > 0) {
          let dataToSend = {
            "merchants": this.fileSelectedOffer.data,
            "headers": this.fileSelectedOffer.headers,
            "type_of_send": {
              "check_whatsapp": this.check_whatsapp,
              "check_email": this.check_email
            }
          }
          this.adminService.sendCampaignDataOffer(dataToSend, this.partnerCode).subscribe((response) => {
            if (!response.error) {
              this.globalServices.prepareAlert({
                title: "Exito",
                message: "Envio de ofertas iniciado correctamente...",
                label: 'success'
              }).subscribe(res => { })
            } else {
              alert(`Error enviando la campana, ${response.message}`);
            }
          });
        } else {
          this.globalServices.prepareAlert({
            title: "Error",
            message: "No existe archivo",
            label: 'error'
          }).subscribe(res => { })
        }
      } else {
        this.globalServices.prepareAlert({
          title: "Error",
          message: "Seleccione un metodo de envio",
          label: 'error'
        }).subscribe(res => { })
      }
    } else {
      this.globalServices.prepareAlert({
        title: "Error",
        message: "Seleccione un proveedor",
        label: 'error'
      }).subscribe(res => { })
    }
  }

  getHeaderArray(csvRecordsArr: any) {  
    let headers = (<string>csvRecordsArr[0]).split(',');  
    let headerArray = [];  
    for (let j = 0; j < headers.length; j++) {  
      headerArray.push(headers[j]);  
    }  
    return headerArray;  
  } 
  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {  
    let csvArr = [];  
  
    for (let i = 1; i < csvRecordsArray.length; i++) {  
      let curruntRecord = (<string>csvRecordsArray[i]).split(',');  
      csvArr.push(curruntRecord);   
    }   
    return csvArr;  
  } 

  verifyPermissionAccess(){
    let modulesPermission = JSON.parse(localStorage.getItem('modulesPermission'));

    if(modulesPermission.includes('send_campaigns')){
      this.permissionAccess = true;
    }
  }

}
